import message from './main';

export default message;
